module.exports = __webpack_public_path__ + "img-front/register/kinesis-third.de43b980.svg";